import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { appContext } from "ui-common/appContext.ts";

export function initTelemetry() {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: "/insights",
      instrumentationKey: "a4003a7e-0068-45de-afcd-432da493ef4f", // random guid just to bypass validation
      userOverrideEndpointUrl: "/api/ins",
      appId: "wow-backoffice",
      loggingLevelTelemetry: 1,
      enableAutoRouteTracking: false, // If enabled, the Application Insights Patches history.pushState and history.replaceState + Listens to the popstate event, so we get double telemetry
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      autoTrackPageVisitTime: true,

      enableUnhandledPromiseRejectionTracking: true,

      extensionConfig: {
        AppInsightsCfgSyncPlugin: {
          cfgUrl: "", // This disables fetching the remote configuration file from https://js.monitor.azure.com/scripts/b/ai.config.1.cfg.json
        },
      },
      disablePageUnloadEvents: ["unload"],
      disableAjaxTracking: true,
      distributedTracingMode: 2, //Send W3C Trace Context headers ONLY

      autoExceptionInstrumented: true,
      correlationHeaderDomains: ["worldofwow.com", "worldofwow.dev"],

      // excludeRequestFromAutoCollection: function (requestContext) {
      //   const url = requestContext?.request?.url || requestContext?.requestUrl || "";

      //   // Example: Exclude any request to '/healthcheck' or some external API
      //   return url.includes("/healthcheck") || url.includes("some-external-api.com");
      // },
    },
  });

  document.addEventListener("click", (e) => {
    const p = e.composedPath();
    const path = p
      .map((x) => {
        if (!x) return;

        const t: { tag?: string; id?: string } = {};
        if ("localName" in x) {
          t.tag = x.localName as string;
        } else if ("tagName" in x) {
          t.tag = x.tagName as string;
        }

        if ("id" in x && x.id != "") {
          t.id = x.id as string;
        } else if ("className" in x) {
          t.id = x.className as string;
        }

        if (t.tag == undefined) return undefined;
        // const t = x as unknown as { localName: string; className?: string; id?: string };
        return t.tag + (t.id ? "." + t.id : "");
      })
      .filter((x) => x != undefined)
      .reverse()
      .join("/");
    appInsights.trackEvent({
      name: "click",

      properties: {
        path,
      },
    });
  });

  appInsights.loadAppInsights();

  appInsights.trackPageView({
    name: document.title,
    uri: window.location.pathname + window.location.search,
    startTime: new Date(),
    isLoggedIn: appContext.isAuthenticated,
  });

  appContext.onSingInCallback = (user) => {
    appInsights.setAuthenticatedUserContext(user.id, user.handle, true);
  };
  appContext.onSignOutCallback = () => {
    appInsights.clearAuthenticatedUserContext();
  };

  window.addEventListener("popstate", (ev: PopStateEvent) => {
    appInsights.trackPageView({
      name: document.title,
      uri: window.location.pathname + window.location.search,
      refUri: location.origin + ev.state?.prevPage,
      startTime: new Date(),
      isLoggedIn: appContext.isAuthenticated,
    });
  });
}
